import { useState } from "react";
import { API } from "@/api";
import Overlay from "@/components/Overlay";
import ProductFilters, { EMPTY_FILTERS, filterProducts } from "@/components/ProductFilters";
import { imagesOf } from "@/components/ProductImages";
import { X, Check } from "lucide-react";

export default function LibraryPicker({ lib, tax, already, onClose, onAdd }) {
  const [f, setF] = useState(EMPTY_FILTERS);
  const [sel, setSel] = useState([]);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const shown = filterProducts(lib, f);
  return (
    <Overlay onClose={onClose} z="z-[60]" className="max-w-2xl" testid="library-picker-modal">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-2xl gold-text">Add from My Products</h3>
        <button onClick={onClose} className="text-slate-400" data-testid="library-picker-close"><X size={20} /></button>
      </div>
      <div className="mt-4"><ProductFilters f={f} setF={setF} tax={tax} prefix="picker" /></div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 mt-3">
        {shown.map((pr) => {
          const inCat = already.includes(pr.id);
          const on = sel.includes(pr.id);
          return (
            <button key={pr.id} disabled={inCat} onClick={() => toggle(pr.id)} className={`relative rounded-xl overflow-hidden border text-left disabled:opacity-40 ${on ? "border-amber-400 ring-2 ring-amber-400/40" : "border-amber-500/15"}`} data-testid={`picker-item-${pr.id}`}>
              <img src={`${API}/files/${imagesOf(pr)[0]}`} alt={pr.name} className="w-full aspect-square object-cover" />
              {(on || inCat) && <span className="absolute top-1.5 right-1.5 h-6 w-6 rounded-full btn-gold flex items-center justify-center"><Check size={13} /></span>}
              <div className="p-1.5 text-[10px] text-slate-200 truncate">{pr.name}</div>
            </button>
          );
        })}
      </div>
      {shown.length === 0 && <p className="text-sm text-slate-400 text-center py-8">No products match these filters.</p>}
      <button disabled={!sel.length} onClick={() => onAdd(sel)} className="w-full btn-gold py-3 rounded-xl mt-4 disabled:opacity-50" data-testid="library-picker-add">Add {sel.length || ""} product{sel.length === 1 ? "" : "s"}</button>
    </Overlay>
  );
}
